import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { EDIT_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const EditRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={EDIT_ROUNDED_GLYPH} />;
